// Angular Files
import { Component, Input } from '@angular/core';

// Angular Material Files

// Other External Files

// Component Files

// Teller Online Files

// Teller Online Library Files
import { TellerOnlineAppService, TellerOnlinePaymentMethodsService } from 'teller-online-libraries/core';

@Component({
    selector: 'app-payment-method-display',
    templateUrl: './payment-method-display.component.html',
    styleUrls: ['./payment-method-display.component.scss'],
    host: {
        class: 'payment-method-display',
        '[class.echeck]': 'isECheck',
        '[class.payment-method-display--radio-button]': 'forRadioButton',
        '[class.payment-method-display--saved]': '!label && !isWallet'
    },
    standalone: false
})
export class PaymentMethodDisplayComponent {
    @Input() isECheck: boolean;

    @Input() last4Digits: string;

    @Input() cardType: string;

    @Input() forRadioButton: boolean = false;

    // When provided, renders icon + this label text (new-method mode).
    // When absent, uses the saved-method wide/narrow logic.
    @Input() label?: string;

    @Input() isWallet: boolean = false;

    @Input() walletMark?: string;

    constructor(
        public appService: TellerOnlineAppService,
        public paymentMethodsService: TellerOnlinePaymentMethodsService
    ) { }
}
